<div class="view-menu" 
  [ngClass]="{
    'view-menu--open': menuMode === menuModeStatus.Opened,
    'view-menu--reset': menuMode === menuModeStatus.Reset
  }">
  
  <!-- Toggle Menu -->
  <div class="view-menu__button" (click)="handleMenuClick()" *ngIf="menuMode !== menuModeStatus.Reset">
    <app-icon icon="bars"></app-icon>
  </div>

  <!-- Reset Menu -->
  <div class="view-menu__button" (click)="handleResetMenuClick()" *ngIf="menuMode === menuModeStatus.Reset">
    <app-icon icon="times"></app-icon>
  </div>



  <!-- Root Menu Options -->
  <div class="view-menu__items">
    <div class="view-menu__item" (click)="handleToolsClick()" *ngIf="isEnabled(viewLayout.Tools)" matTooltip="Explore Tools">
      <app-icon icon="pen"></app-icon>
    </div>
    
    <div appHideIE11 class="view-menu__item" (click)="handleSearchClick()" *ngIf="isEnabled(viewLayout.Search)" matTooltip="Search">
      <app-icon icon="search"></app-icon>
    </div>

    <div class="view-menu__item" (click)="handleFullscreenClick()" *ngIf="canFullscreen && isEnabled(viewLayout.Fullscreen)" matTooltip="Expand">
      <app-icon icon="expand"></app-icon>
    </div>

    <div class="view-menu__item" (click)="handleNewTabClick()" *ngIf="!canFullscreen && isEnabled(viewLayout.Fullscreen)" matTooltip="Launch in new tab">
      <app-icon icon="external-link"></app-icon>
    </div>
    
    <div class="view-menu__item" [matMenuTriggerFor]="moreMenu" matTooltip="More...">
      <app-icon icon="ellipsis-v"></app-icon>
    </div>
    
    
  </div>
</div>


<!-- More Menu -->
<mat-menu #moreMenu="matMenu">
  <!-- Help -->
  <button mat-menu-item (click)="handleHelpClick()" *ngIf="isEnabled(viewLayout.Help)">
    Help
  </button>

  <!-- Toggles -->
  <button mat-menu-item (click)="handleToggleLabelsClick()" [disabled]="!(labels$ | async)?.length">
    <ng-container *ngIf="showLabels$ | async">Hide labels</ng-container>
    <ng-container *ngIf="!(showLabels$ | async)">Show labels</ng-container>
  </button>
</mat-menu>